/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var DoordashDisputeReason;
(function (DoordashDisputeReason) {
    DoordashDisputeReason["ITEM_PREPARED_AS_REQUESTED"] = "item_prepared_as_requested";
    DoordashDisputeReason["ORDER_HANDLED_IMPROPERLY"] = "order_handled_improperly";
    DoordashDisputeReason["ITEM_NOT_PICKED_UP"] = "item_not_picked_up";
    DoordashDisputeReason["ORDER_PICKED_UP_LATE"] = "order_picked_up_late";
    DoordashDisputeReason["OTHER_REASON"] = "other_reason";
    DoordashDisputeReason["CONFIRMED_DURING_HANDOFF"] = "confirmed_during_handoff";
})(DoordashDisputeReason || (DoordashDisputeReason = {}));
